export const core = {
  error: {
    title: 'Contenido no disponible',
    message: 'No pudimos cargar la información solicitada. Por favor, inténtalo de nuevo más tarde.',
  },
  footer: {
    sections: [
      {
        title: 'Información General',
        links: [
          { title: 'Reglas de pronosticos', href: '/info/bet-rules' },
          { title: 'Depósitos', href: '/info/deposits' },
          { title: 'Retiros', href: '/info/withdrawals' },
          { title: 'Límite de Pronósticos', href: '/info/betting-limit' },
        ],
      },
      {
        title: 'Nuestras Secciones',
        links: [
          { title: 'Inicio', href: '/' },
          { title: 'Casino', href: '/casino' },
          { title: 'Deportes', href: '/deportes' },
          { title: 'Perfil', href: '/dashboard' },
          { title: 'Retiros', href: '/dashboard/withdrawals' },
        ],
      },
      {
        title: 'Seguridad & Privacidad',
        links: [
          { title: 'Política de Privacidad', href: '/info/privacy' },
          { title: 'Términos y Condiciones', href: '/info/terms-and-conditions' },
          { title: 'Condiciones de Bonos', href: '/info/bonus-conditions' },
          { title: 'Juego Responsable', href: '/info/responsibility' },
          { title: 'Políticas KYC', href: '/info/kyc-policies' },
          { title: 'Anti-Lavado de Dinero', href: '/info/money-laundering' },
        ],
      },
      {
        title: '¿Necesitas ayuda?',
        links: [
          { title: 'Preguntas Frecuentes', href: '/info/faq' },
          { title: 'Contáctanos', href: 'https://api.whatsapp.com/send?phone=50492062735&text=%C2%A1Hola', external: true },
          { title: 'Resolución de Disputas', href: '/info/disputes' },
          { title: '¿Quieres ser Agente Powerbet?', href: '/nuevo-agente' },
        ],
      },
    ],
  },
};
